'use strict';

const controllerModule = angular.module('tdl.controllers', ['tdl.config', 'tdl.filters', 'tdl.services']);

export default controllerModule;
